import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../shared/form-elements/multiselect/select';

lessRequire('modules/offers/components/filters/languages.less');

const propTypes = {
	form: PropTypes.string,
	intl: PropTypes.func,
	languagesOptions: PropTypes.array
};

const Form = ({ intl, languagesOptions }) => (
	<form
		action="#"
		className="offer-domains-languages">
		<div className="offer-domains-language__item">
			<Field
				name="lang"
				placeholder={intl('Все языки')}
				component={SelectField}
				options={getOptions(languagesOptions, intl)}
				multi={false}
			/>
		</div>
	</form>
);

const getOptions = (languagesOptions, intl) => {
	const defaultOptions = [{
		value: 'all',
		label: intl('Все языки')
	}];

	return [].concat(defaultOptions, languagesOptions);
};

Form.propTypes = propTypes;
export default reduxForm({
	initialValues: {
		lang: 'all'
	}
})(Form);




// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/filters/languages.js